<template>
  <div class="btn-segmented" :class="{ disabled: disabled }">
    <button
      v-for="(option, index) in options"
      :key="index"
      class="btn"
      :class="{ selected: value === option.value}"
      @click="$emit('input', option.value)"
    >
      <component :is="option.icon" v-if="option.icon" />
      <template v-if="option.label">{{ option.label }}</template>
    </button>
  </div>
</template>

<script>
  import BarChartIcon from '@/_legacy/components/Icons/BarChart.vue';
  import LineChartIcon from '@/_legacy/components/Icons/LineChart.vue';

  export default {
    components: {
      BarChartIcon,
      LineChartIcon,
    },
    props: {
      options: {
        type: Array,
        default: () => [],
      },
      value: {
        type: [String, Number, Object],
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    computed: {},
    methods: {},
  };
</script>
